// return development or production url
export const developmentUrl = (path: string) => {
  const projectEnv = process.env.NODE_ENV
  return projectEnv === 'development' ? `/${path}` : `${process.env.REACT_APP_API_HOST}/${path}`
}
